"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPlacements = void 0;
const NotificationPlacements = exports.NotificationPlacements = ['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight'];